import {
  type CountryCode,
  type CountryForCode,
  lookupCountry,
} from './countries.js'

/**
 * The {@link CountryCode}s representing countries in which Owner operates. For
 * the complete list of ISO-standard country codes, see {@link COUNTRY_CODES}.
 */
export const OPERATING_COUNTRY_CODES = [
  'US',
  'CA',
] as const satisfies readonly CountryCode[]

/**
 * The {@link Country}s in which Owner operates. For the complete list of
 * ISO-standard countries, see {@link COUNTRIES}.
 */
export const OPERATING_COUNTRIES = OPERATING_COUNTRY_CODES.map((x) =>
  lookupCountry(x)
) satisfies readonly OperatingCountry[]

/**
 * An ISO 3166-1 alpha-2 code representing a country in which Owner operates.
 */
export type OperatingCountryCode = (typeof OPERATING_COUNTRY_CODES)[number]

/** A country in which Owner operates. */
export type OperatingCountry = CountryForCode<OperatingCountryCode>

/**
 * Narrows an arbitrary string to an {@link OperatingCountryCode}.
 *
 * @param value the string to check
 * @return true iff the supplied string is a valid `OperatingCountryCode`
 */
export const isOperatingCountryCode = (
  value: string | null | undefined
): value is OperatingCountryCode =>
  OPERATING_COUNTRY_CODES.includes(value as OperatingCountryCode)
